// Returns an array with duplicate elements removed
// preserves the input order
export const unique = <T>(input: T[], keySelector?: (elem: T) => string | number) => {
    const seen: { [s: string]: boolean } = {};

    if (!keySelector) {
        keySelector = (elem: T) => elem as any; // tslint:disable-line:no-any
    }

    return input.filter(elem => {
        const key = `${keySelector!(elem)}`;
        if (typeof seen[key] === 'undefined') {
            seen[key] = true;
            return true;
        }
        return false;
    });
};


// WEBPACK FOOTER //
// ./src/util/unique.ts